import * as React from "react";
const ActiveVoiceIcon = (props) => (
  <svg
      width={props.width?props.width:"26px"}
    height={props.height?props.height:"26px"}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={48} height={48} fill="white" fillOpacity={0.01} />
    <path
      d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
      fill="#2F88FF"
      stroke="black"
      strokeWidth={4}
    />
    <path d="M30 18V30" stroke="white" strokeWidth={4} strokeLinecap="round" />
    <path d="M36 22V26" stroke="white" strokeWidth={4} strokeLinecap="round" />
    <path d="M18 18V30" stroke="white" strokeWidth={4} strokeLinecap="round" />
    <path d="M12 22V26" stroke="white" strokeWidth={4} strokeLinecap="round" />
    <path d="M24 14V34" stroke="white" strokeWidth={4} strokeLinecap="round" />
  </svg>
);
export default ActiveVoiceIcon;
